import { pushGTMEvent } from "utils/gtmEvent";

type EventPayload = Parameters<typeof pushGTMEvent>[0];

const GA_DEDUP_PREFIX = "ga-event-dedup";

export const pushGTMEventOnce = (dedupKey: string, eventPayload: EventPayload) => {
    if (globalThis.window === undefined) {
        return;
    }

    const storageKey = `${GA_DEDUP_PREFIX}:${dedupKey}`;
    const alreadyPushed = globalThis.window.sessionStorage.getItem(storageKey) === "1";

    if (alreadyPushed) {
        return;
    }

    pushGTMEvent(eventPayload);
    globalThis.window.sessionStorage.setItem(storageKey, "1");
};
